<template lang="pug">
  v-layout(align-start)
    v-flex
      v-app-bar(dark color='primary')
        v-toolbar-title.head-transferir TRANSFERENCIA DE ALMACEN
      v-card
        v-row(dense)
          v-col(cols='12')
            v-card-subtitle.title(style='color: black; padding: 16px 16px 0px 16px;') Almacen
            v-card-text(style='padding: 16px 16px 16px 16px;')
              v-row(dense)
                v-col(cols='12' sm='12' md='12')
                  v-autocomplete( autocomplete="off" v-model='almacenSelec' dense outlined label="Seleccione" :items="almacenes" @change="almacenSeleccionado" loading-text='Cargando, por favor espere...')
                v-col(cols='12' sm='12' md='12' )
                  v-data-table.elevation-4(:headers='headers' :items='productos' :loading='loading')
                    template(v-slot:item.action='{ item }')
                      v-tooltip(bottom='')
                        template(v-slot:activator='{ on }')
                          v-icon.mr-2(color='success' @click='editItem(item)' v-on="on") mdi-transfer-right
                        | Transferir de Almacen
                    template(v-slot:no-data)
                      h2.pa-2 No hay productos en este almacen

      v-dialog(v-model='dialog' scrollable persistent content-class="flex xs12 sm8")
        v-card
          v-card-title
            span.headline Transferir Producto
          v-card-text
            v-container
              v-row
                v-col(cols='12' sm='12' md='12')
                  v-text-field(dense outlined readonly v-model='form.idProducto.nombre' id="codigo" label='Codigo')
              v-row
                v-col(cols='12' sm='12' md='12')
                  v-text-field(dense outlined readonly v-model='form.idProducto.descripcion' id="nombre" label='Nombre')
              v-row
                v-col(cols='12' sm='12' md='12')
                  v-text-field(dense outlined  readonly type='number' v-model.number='form.cantidad' id="Cantidad" label='Stock')
              v-row
                v-col(cols='12' sm='12' md='12')
                  v-text-field(dense outlined  type='number' v-model.number='form.cantidadTransferir' id="trans" label='Cantidad a transferir')
              v-row
                v-col(cols='12' sm='12' md='12')
                  v-select(dense outlined  id="transferir" v-model='form.almacenEnviado' :items='almacenesTransferir' label='Almacen a transferir')
          v-card-actions
            v-spacer
            v-btn(color='error' small='' dark='' @click='close')
              v-icon mdi-close
              | Cancelar
            v-btn(color='success' small='' dark='' @click='save')
              v-icon mdi-content-save
              | Guardar
</template>

<script>
import Api from '@/services/methods'
export default {
  data: () => ({
    loading: false,
    dialog: false,
    editedIndex: -1,
    almacenes: [],
    almacenSelec: null,
    almacenesTransferir: [],
    productos: [],
    kardex: [],
    headers: [
      {
        text: 'Codigo',
        align: 'left',
        sortable: false,
        value: 'idProducto.nombre'
      },
      { text: 'Nombre', value: 'idProducto.descripcion' },
      { text: 'Unidad de Medida', value: 'idProducto.unidadMedida' },
      { text: 'Stock', value: 'cantidad' },
      // { text: 'IVA', value: 'idIva.descripcion' },
      // { text: 'Precio', value: 'precio' }
      { text: 'Transferir', value: 'action', sortable: false }
    ],
    form: {
      transferir: 0,
      idProducto: {
        nombre: '',
        descripcion: ''
      }
    }
  }),

  created () {
    this.initialize()
  },
  methods: {
    initialize () {
      this.listarAlmacenes()
    },

    editItem (item) {
      this.editedIndex = this.productos.indexOf(item)
      this.form = Object.assign({}, item)
      this.dialog = true
    },

    almacenSeleccionado (data) {
      this.loading = true
      this.productos = []
      const pos = this.almacenes.findIndex(almacen => almacen.value === data)
      this.almacenesTransferir = [...this.almacenes]
      this.almacenesTransferir.splice(pos, 1)
      this.listarProductos(data)
    },

    listarAlmacenes () {
      Api.get('almacen')
        .then(response => {
          response.data.map(almacen => {
            this.almacenes.push({
              value: almacen._id,
              text: almacen.descripcion
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },

    listarProductos (idAlmacen) {
      Api.get('proalma/almacen/' + idAlmacen)
        .then(response => {
          console.log(response.data)
          this.loading = false
          this.productos = response.data
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al modificar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },

    validateCampos () {
      if (
        this.form.cantidadTransferir <= 0 ||
        !this.form.cantidadTransferir ||
        isNaN(this.form.cantidadTransferir) ||
        !this.form.almacenEnviado
      ) {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor llene todos los campos para continuar'
        })
        return true
      }
      return false
    },

    validateStock () {
      if (this.form.cantidadTransferir > this.form.cantidad) {
        this.$swal({
          icon: 'error',
          title: 'Cantidad mayor al stock',
          text: 'Por favor introduza una cantidad correcta para guardar'
        })
        return true
      }
      return false
    },

    save () {
      if (!this.validateCampos() && !this.validateStock()) {
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            this.$swal.showLoading()
          }
        })
        Api.post('proalma/transferir', this.form)
          .then(response => {
            this.form.cantidad -= this.form.cantidadTransferir
            this.form.almacenEnviado = null
            this.form.cantidadTransferir = null
            this.$swal({
              icon: 'success',
              title: 'Transferencia exitosa',
              text: 'Todos los datos han sido guardados'
            })
            Object.assign(this.productos[this.editedIndex], this.form)
            this.close()
          })
          .catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: 'Error al guardar',
                text: 'Por favor, verifique los datos e intente de nuevo'
              })
            } else if (error.request) {
              this.$swal({
                icon: 'error',
                title: 'Error de red',
                text: 'Por favor verique su conexion de internet'
              })
            } else {
              console.log('Error', error.message);
            }
          })
      }
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    }
  }
}
</script>
<style lang="scss">
  .head-transferir {
      font-size: 1.5rem;
  }
  @media screen and (max-width: 425px) {
    .head-transferir {
      font-size: 1rem;
    }
  }
</style>